import { render } from "./PurchasePaymentListComponent.vue?vue&type=template&id=5083beed"
import script from "./PurchasePaymentListComponent.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/purchase/PurchasePaymentListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5083beed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5083beed', __exports__)) {
    api.reload('5083beed', __exports__)
  }
  
  module.hot.accept("./PurchasePaymentListComponent.vue?vue&type=template&id=5083beed", () => {
    api.rerender('5083beed', render)
  })

}


export default __exports__